export const TOGGLE_BOXED_LAYOUT = 'TOGGLE_BOXED_LAYOUT';
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSED_NAV';
export const TOGGLE_NAV_BEHIND = 'TOGGLE_NAV_BEHIND';
export const TOGGLE_FIXED_HEADER = 'TOGGLE_FIXED_HEADER';
export const CHANGE_SIDEBAR_WIDTH = 'CHANGE_SIDEBAR_WIDTH';
export const CHANGE_COLOR_OPTION = 'CHANGE_COLOR_OPTION';
export const CHANGE_THEME = 'CHANGE_THEME';
export const SEL_COMPLETA = 'SEL_COMPLETA';
export const SEL_TERCERO = 'SEL_TERCERO';
export const GUAR_CARRO = 'GUAR_CARRO';
export const SEL_SEGURO = 'SEL_SEGURO';
export const SEL_TERCERO_2 = 'SEL_TERCERO_2';
export const SEL_TERCERO_3 = 'SEL_TERCERO_3';
export const SEL_TERSEGURO = 'SEL_TERSEGURO';
export const TIPO_COBERTURA = 'TIPO_COBERTURA';
export const NO_COBERTURACC = 'NO_COBERTURACC';
export const QUOTE = 'QUOTE';
export const QUOTERES = 'QUOTERES';
export const PDF = 'PDF';
export const SPINNER_PAGO = 'SPINNER_PAGO';
export const LIMITES = 'LIMITES';
export const INTER_LISTO = 'INTER_LISTO';
export const GUAR_CARRO_DT = 'GUAR_CARRO_DT';
export const AUTO_MOTO = 'AUTO_MOTO';
export const SEL_TERCERO_MOTOS = 'SEL_TERCERO_MOTOS';
export const COLORES = 'COLORES';
export const ESTADOS = 'ESTADOS';
export const VIEWED_MODAL = 'VIEWED_MODAL';




// WEBPACK FOOTER //
// ./constants/ActionTypes.js